import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const PageListIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M11.318 4.79541C11.318 4.3812 10.9822 4.04541 10.568 4.04541H2.88637C2.47215 4.04541 2.13637 4.3812 2.13637 4.79541V13.7495C2.13637 14.1637 2.47215 14.4995 2.88637 14.4995H10.568C10.9822 14.4995 11.318 14.1637 11.318 13.7495V4.79541ZM12.318 13.7495C12.318 14.716 11.5345 15.4995 10.568 15.4995H2.88637C1.91987 15.4995 1.13637 14.716 1.13637 13.7495V4.79541C1.13637 3.82891 1.91987 3.04541 2.88637 3.04541H10.568C11.5345 3.04541 12.318 3.82891 12.318 4.79541V13.7495Z"
      fill="currentColor"
    />
    <path
      d="M13.8633 12.5V3.25C13.8633 2.2835 13.0798 1.5 12.1133 1.5H3.50005C3.2239 1.5 3.00005 1.27614 3.00005 1C3.00005 0.723858 3.2239 0.5 3.50005 0.5H12.1133C13.6321 0.5 14.8633 1.73122 14.8633 3.25V12.5C14.8633 12.7761 14.6395 13 14.3633 13C14.0873 12.9998 13.8633 12.776 13.8633 12.5Z"
      fill="currentColor"
    />
    <path
      d="M9.27264 6.22726C9.54879 6.22726 9.77264 6.45112 9.77264 6.72726C9.77264 7.00341 9.54879 7.22726 9.27264 7.22726H4.18182C3.90568 7.22726 3.68182 7.00341 3.68182 6.72726C3.68182 6.45112 3.90568 6.22726 4.18182 6.22726H9.27264Z"
      fill="currentColor"
    />
    <path
      d="M9.27264 8.77274C9.54879 8.77274 9.77264 8.99659 9.77264 9.27274C9.77264 9.54888 9.54879 9.77274 9.27264 9.77274H4.18182C3.90568 9.77274 3.68182 9.54888 3.68182 9.27274C3.68182 8.99659 3.90568 8.77274 4.18182 8.77274H9.27264Z"
      fill="currentColor"
    />
    <path
      d="M6.72772 11.3182C7.00366 11.3184 7.22772 11.5422 7.22772 11.8182C7.22772 12.0942 7.00366 12.3179 6.72772 12.3182H4.18182C3.90568 12.3182 3.68182 12.0943 3.68182 11.8182C3.68182 11.542 3.90568 11.3182 4.18182 11.3182H6.72772Z"
      fill="currentColor"
    />
  </svg>
);
